import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { OGPATHS, PATHS } from "src-ironside/app-routing.module";
import { CustomTranslateService } from "src/app/shared/services/custom-translate.service";

@Injectable({
    providedIn: 'root',
})
export class RouterService {
    routes: any = PATHS;
    originalRoutes: any = OGPATHS;

    constructor(private router: Router, private translateService: CustomTranslateService) {
    }

    translateRoute(originalPath?: string) {
        if (!originalPath) {
            originalPath = ''
            let refToSave = false;
            let ref = '';
            let urlArray = window.location.pathname.split('/');
            let pathMap = new Map<string, string>(Object.entries(this.routes));

            for (let i = 0; i < urlArray.length; i++) {
                let matching_path_index = Array.from(pathMap.values()).findIndex(el => el == urlArray[i]);
                let matching_path = Array.from(pathMap.keys())[matching_path_index];

                if (matching_path?.includes('_')) {
                    matching_path = matching_path.split('_')[0];
                }

                if (matching_path) {
                    refToSave = true;
                    originalPath += '/' + matching_path 
                }

                if (!matching_path && refToSave) {
                    ref = urlArray[i];
                    originalPath += '/' + ref
                }
            }
        }

        setTimeout(() => {
            let ogPath = originalPath ? originalPath : ('/' + OGPATHS.home);
            this.router.navigate([this.getTranslatedRoute(ogPath)])
        }, 200)
    }

    getTranslatedRoute(route?: string) {
        if (route) {
            let lang = this.translateService.currentLang;
            let finalRoute = `/${lang}/`
            let routeArray = route.split('/');

            for (let i = 1; i < routeArray.length; i++) {
                if (this.routes[`${routeArray[i]}_${lang}`]) {
                    routeArray[i] = this.routes[`${routeArray[i]}_${lang}`].split(' ').join('_');
                }
            }
            return finalRoute + routeArray.join('/')
        }
        return;
    }
}